import React from 'react'
import { Flex, Box, Label, Checkbox, Text } from 'pcln-design-system'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { Discount } from 'pcln-icons'
import { ProductOption } from '../Flights/types'
import analytics from '../../utils/analytics'

type ProductCheckBoxType = {
  category: string
  productOptions: Readonly<ProductOption[]>
  tripType: string
  label: string
  setValue: (key: string, value: string) => void
  color?: string
  isStickySearch?: boolean
}

const StyledText = styled(Text).attrs(() => ({
  pr: [1, 2, null, 3]
}))`
  white-space: nowrap;
`

const VariantFlex = styled(Flex)`
  border-radius: 6px;
`

const FlexWrapper = ({
  children,
  isDefault
}: {
  children: React.ReactNode
  isDefault: boolean
}) => {
  return isDefault ? (
    <Flex alignItems="center">{children}</Flex>
  ) : (
    <VariantFlex
      alignItems="center"
      color="success.light"
      p={1}
      mt={[0, 3, null, null, 0]}
      mr={[2, 0]}
    >
      {children}
    </VariantFlex>
  )
}

export default function ProductCheckBox({
  category,
  productOptions,
  tripType,
  label,
  setValue,
  color = 'gray',
  isStickySearch = false
}: ProductCheckBoxType) {
  const {
    query: { tab = 'hotels' },
    pathname
  } = useRouter()
  const isHomepage = pathname === '/'
  const parent = isHomepage ? `${tab}-` : ''
  return (
    <>
      <FlexWrapper isDefault={isStickySearch}>
        {isStickySearch ? (
          <StyledText fontSize={0} color={color}>
            {label}
          </StyledText>
        ) : (
          <Flex>
            <Discount m={1} mr={2} color="success.dark" />
            <StyledText
              color="success.dark"
              bold
              fontSize={[0, null, null, null, 1]}
              m="auto"
            >
              {label}
            </StyledText>
          </Flex>
        )}
        <Flex flexWrap="wrap" alignItems="center">
          {productOptions.map(option => {
            const checked = tripType.includes(option.type)
            return (
              <Box key={option.name} mt="2px" pr={[1, 2, 3]}>
                <Label fontSize={0} htmlFor={option.id} color={color}>
                  <Checkbox
                    aria-label={option.label}
                    id={option.id}
                    data-testid={option.id}
                    name={option.name}
                    value={option.type}
                    checked={checked}
                    onChange={(
                      e: React.ChangeEvent<HTMLInputElement>
                    ): void => {
                      let value = tripType
                      if (e.target.checked) {
                        value = `${tripType}:${e.target.value}`
                        analytics.fireEvent({
                          action: 'Add Product Checkbox',
                          category,
                          label: `${parent}${option.label}`
                        })
                      } else {
                        value = tripType.replace(`:${e.target.value}`, '')
                      }
                      setValue('tripType', value)
                    }}
                  />
                  {` ${option.label} `}
                </Label>
              </Box>
            )
          })}
        </Flex>
      </FlexWrapper>
    </>
  )
}
